// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2ExIq","insightsList":"newBusinessInsightsMenu_insightsList__3JJua","active":"newBusinessInsightsMenu_active__2evZf"};